export default {
  // Brand
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "ACB Spreadsheet",
  tagline: "The AllChinaBuy Resource Center",
  independentNote: "This is an independent informational resource and is not the official AllChinaBuy website.",

  // Nav
  nav: {
    home: "Home",
    spreadsheet: "Spreadsheet",
    categories: "Categories",
    guides: "Guides",
    shoppingGuide: "Shopping Guide",
    browseCategories: "Browse Categories",
    faq: "FAQ",
  },

  // Hero
  hero: {
    eyebrow: "THE ALLCHINABUY RESOURCE CENTER",
    title: "AllChinaBuy Spreadsheet — Discover Better Finds, Sellers & Buying Guides",
    subtitle: "Explore organized AllChinaBuy spreadsheet finds, product categories, QC resources, seller information, shipping guides and practical buying tips — all in one place.",
    ctaPrimary: "AllChinaBuy Spreadsheet",
    ctaSecondary: "Buy It Now",
    trust: "Independent resource • Updated guides • Buyer-focused information",
    searchPlaceholder: "Search AllChinaBuy spreadsheet, shoes, hoodies, QC, shipping...",
  },

  // Hero value cards
  cards: {
    findsTitle: "Organized Finds",
    findsDesc: "Browse curated AllChinaBuy spreadsheet resources by category and product type.",
    qcTitle: "QC Resources",
    qcDesc: "Learn how to understand QC photos, product details and seller information.",
    shippingTitle: "Shipping Guides",
    shippingDesc: "Understand international shipping options, costs and common considerations.",
    buyingTitle: "Buyer Guides",
    buyingDesc: "Follow practical guides designed for beginners and experienced buyers.",
  },

  // Spreadsheet preview
  preview: {
    title: "AllChinaBuy Spreadsheet Preview",
    subtitle: "A quick look at how our spreadsheet organizes finds, QC status and seller information.",
    colProduct: "Product",
    colCategory: "Category",
    colQc: "QC",
    colSeller: "Seller",
    colStatus: "Status",
    updated: "Updated",
    fresh: "New",
    verified: "Verified Info",
    sellerInfo: "Seller Info",
  },

  // Categories
  categories: {
    title: "Browse Product Categories",
    subtitle: "Jump straight to any category on the main website and explore organized AllChinaBuy spreadsheet finds.",
    dropdownLabel: "Choose a category",
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "underwear/underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },

  // Text module (SEO article on homepage)
  content: {
    title: "What Is the AllChinaBuy Spreadsheet?",
    p1: "The AllChinaBuy spreadsheet is a structured resource that organizes product finds, seller information, quality-check (QC) notes and shipping details into one place. Instead of scrolling through scattered listings, buyers use it to compare options side by side and make more informed choices before placing an order.",
    p2: "A well-organized AllChinaBuy spreadsheet typically groups products by category — shoes, hoodies, t-shirts, jackets, bags and accessories — then adds practical fields such as QC status, seller reliability and last-updated date. This layout helps both first-time buyers and experienced shoppers spot quality items faster.",
    p3: "Beyond product discovery, the spreadsheet works as a buyer guide. It can include notes on how to read QC photos, how to evaluate sellers, and what to watch for during international shipping. Combined with our buying guides, it turns a raw list into a genuinely useful decision-making tool.",
    linkLabel: "Read the complete AllChinaBuy spreadsheet guide",
  },

  // Article entry
  articleEntry: {
    title: "Featured Guide",
    subtitle: "Original, in-depth resources written around the AllChinaBuy spreadsheet topic.",
    cardTitle: "AllChinaBuy Spreadsheet: The Complete Buyer Guide",
    cardDesc: "Learn how to use the AllChinaBuy spreadsheet, evaluate sellers, read QC photos and choose products with confidence.",
    readMore: "Read the Guide",
  },

  pillars: {
    title: "Explore Our Buyer Guides",
    subtitle: "Original, in-depth resources covering reviews, shipping, QC, sellers, safety and more — all built around the AllChinaBuy spreadsheet.",
    readMore: "Read More",
    minRead: "min read",
  },

  // FAQ
  faq: {
    title: "Frequently Asked Questions",
    q1: "Is this the official AllChinaBuy website?",
    a1: "No. This is an independent informational resource that helps buyers understand and use AllChinaBuy spreadsheet finds, QC tips and shipping guides. It is not affiliated with the official AllChinaBuy platform.",
    q2: "What can I find in the AllChinaBuy spreadsheet?",
    a2: "Organized product finds across categories like shoes, hoodies, t-shirts, jackets, bags and accessories — each with useful fields such as QC status, seller information and last-updated date.",
    q3: "How do the categories work?",
    a3: "Every category button and the dropdown take you directly to the matching section on the main website, where you can browse products in that category.",
    q4: "Where can I actually buy these products?",
    a4: "All products are available on the main website. Use the \"AllChinaBuy Spreadsheet\" or \"Buy It Now\" buttons to continue there.",
  },

  // Footer
  footer: {
    aboutTitle: "About This Site",
    aboutDesc: "An independent AllChinaBuy spreadsheet and buyer resource center. We help you find products faster and shop with better information.",
    exploreTitle: "Explore",
    disclaimer: "This is an independent informational resource and is not the official AllChinaBuy website unless explicitly stated.",
    rights: "All rights reserved.",
  },

  // Language names
  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
};